export const manifest = {
  screens: {
    scr_v51twk: { name: "Prevention — Risk Matrix", route: "/", state: {"tab":"prevention","subTab":"risk_matrix"}, position: {"x":1560,"y":220} },
    scr_fn5yg2: { name: "Prevention — Insights & Corrective Actions", route: "/", state: {"tab":"prevention","subTab":"recommendations"}, position: {"x":2960,"y":220} },
    scr_v4mhwy: { name: "Prevention — Trends", route: "/", state: {"tab":"prevention","subTab":"analytics"}, position: {"x":4360,"y":220} },
    scr_otjr01: { name: "Dashboard — Compliance", route: "/", state: {"tab":"compliance"}, position: {"x":160,"y":220} },
    scr_rgwpvt: { name: "Bilton AI", route: "/bilton-ai", position: {"x":160,"y":2200} },
    scr_ky9z9g: { name: "Workers", route: "/workers", position: {"x":1560,"y":2200} },
    scr_audygj: { name: "Inspections", route: "/inspections", position: {"x":2960,"y":2200} },
    scr_vm3n9k: { name: "Documents", route: "/documents", position: {"x":4360,"y":2200} },
    scr_ww9loz: { name: "Pre-Shift", route: "/pre-shift", position: {"x":160,"y":4180} },
    scr_9wgcsz: { name: "Toolbox Talk", route: "/toolbox-talk", position: {"x":1560,"y":4180} },
    scr_451jwu: { name: "JHA", route: "/jha", position: {"x":2960,"y":4180} },
    scr_lbdr9m: { name: "PTP", route: "/ptp", position: {"x":4360,"y":4180} },
  },
  sections: {
    sec_0yum23: { name: "Dashboard & Prevention", x: 0, y: 0, width: 5720, height: 1180 },
    sec_exqi9p: { name: "Core Features", x: 0, y: 1980, width: 5720, height: 1180 },
    sec_cxpqcl: { name: "Safety Activities", x: 0, y: 3960, width: 5720, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_0yum23", children: [
      { kind: "screen", id: "scr_otjr01" },
      { kind: "screen", id: "scr_v51twk" },
      { kind: "screen", id: "scr_fn5yg2" },
      { kind: "screen", id: "scr_v4mhwy" },
    ] },
    { kind: "section", id: "sec_exqi9p", children: [
      { kind: "screen", id: "scr_rgwpvt" },
      { kind: "screen", id: "scr_ky9z9g" },
      { kind: "screen", id: "scr_audygj" },
      { kind: "screen", id: "scr_vm3n9k" },
    ] },
    { kind: "section", id: "sec_cxpqcl", children: [
      { kind: "screen", id: "scr_ww9loz" },
      { kind: "screen", id: "scr_9wgcsz" },
      { kind: "screen", id: "scr_451jwu" },
      { kind: "screen", id: "scr_lbdr9m" },
    ] },
  ],
}
